export default __webpack_public_path__ + "static/media/gods.2bce34ec.png";